<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>
        
        <div slot="input">
            <div
                v-for="(item, index) in content"
                :key="index"
                class="relative mb-2"
            >
                <input 
                    type="text" 
                    class="input"
                    :class="options" 
                    v-bind="$attrs" 
                    v-model="content[index]"
                />

                <span class="absolute text-red cursor-pointer hover:text-blue" style="right: 1rem; top: 1rem; font-size: 1rem;" @click="deleteItem(index)">
                    <app-icon icon="times" />
                </span>
            </div>

            <app-button element="a" class="btn  btn--tertiary  btn--tertiary--sml" @click="add">
                Add Item
            </app-button>
        </div>
    </app-field>
</template>

<script>
    import Vue from 'vue';

    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    import Button from '@/components/Button';

    export default {
        name: 'app-field-text',
        components: {
            'app-field': Field,
            'app-label': Label,
            'app-button': Button
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ['']
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            }
        },

        data: () => ({
            content: []
        }),

        mounted() {
            this.content = this.value.length > 0 ? this.value : ['']
        },

        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },

        methods: {
            update() {
                this.$emit('input', this.content)
            },
            add() {
                this.content.push('');
            },
            deleteItem(index) {
                Vue.delete(this.content, index);
            }
        },

        watch: {
            content() {
                this.update();
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>


// WEBPACK FOOTER //
// src/components/fields/inputs/Repeatable.vue